export type ClientProposalHosting = 120 | 240;
export type ClientProposalPageScope = "current" | "eight";

export interface ClientProposalOptions {
  hosting: ClientProposalHosting;
  pageScope: ClientProposalPageScope;
}

export interface ParsedClientProposal {
  options: ClientProposalOptions;
  note: string;
}

export const DEFAULT_CLIENT_PROPOSAL_OPTIONS: ClientProposalOptions = {
  hosting: 240,
  pageScope: "current",
};

const COMMAND_PATTERN =
  /^\/client-proposal hosting_sgd_per_year=(120|240) (page_scope=current|page_allowance_total=8)(?:\n\n([\s\S]*))?$/;

export function formatClientProposalDraft(
  options: ClientProposalOptions,
  note: string,
): string {
  const pageArgument =
    options.pageScope === "eight"
      ? "page_allowance_total=8"
      : "page_scope=current";
  const command = `/client-proposal hosting_sgd_per_year=${options.hosting} ${pageArgument}`;
  return note.trim() ? `${command}\n\n${note}` : command;
}

export function parseClientProposalDraft(
  rawDraft: string,
): ParsedClientProposal | null {
  const match = COMMAND_PATTERN.exec(rawDraft);
  if (!match) return null;

  return {
    options: {
      hosting: Number(match[1]) as ClientProposalHosting,
      pageScope: match[2] === "page_allowance_total=8" ? "eight" : "current",
    },
    note: match[3] ?? "",
  };
}

export function stripTypedClientProposalAlias(value: string): string | null {
  const match = /(^|\s)\/client(?:-| )proposal$/i.exec(value);
  if (!match || match.index === undefined) return null;
  const tokenStart = match.index + match[1].length;
  return value.slice(0, tokenStart).trimEnd();
}
